/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campus_Placeholder_BodyInputs */

const en_campus_placeholder_body = /** @type {(inputs: Campus_Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Campus map uses GPS-based coordinates and a different parsing pipeline. Support is planned in a future iteration.`)
};

const fr_campus_placeholder_body = /** @type {(inputs: Campus_Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La carte Campus utilise des coordonnées GPS et une chaîne de parsing différente. Sa prise en charge est prévue dans une prochaine itération.`)
};

const ms_sg2_campus_placeholder_body = /** @type {(inputs: Campus_Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta Kampus menggunakan koordinat GPS dan saluran penghuraian yang berbeza. Sokongan dirancang dalam lelaran masa depan.`)
};

/**
* | output |
* | --- |
* | "The Campus map uses GPS-based coordinates and a different parsing pipeline. Support is planned in a future iteration." |
*
* @param {Campus_Placeholder_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const campus_placeholder_body = /** @type {((inputs?: Campus_Placeholder_BodyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campus_Placeholder_BodyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campus_placeholder_body(inputs)
	if (locale === "fr") return fr_campus_placeholder_body(inputs)
	return ms_sg2_campus_placeholder_body(inputs)
});